import React from 'react';

import { SectionCard } from '~components';
import Icon, { faInfoCircle } from '~components/icon';
import { Pie } from '~components/visualisation';
import { PieDatum } from '~components/visualisation/pie/Pie.types';

import { formatCompactCurrency } from '~libs/formatters';

interface ComponentProps {
  title: string;
  description: string;
  data: PieDatum[];
}

export const DashboardPieChart: React.FC<ComponentProps> = ({ title, description, data }) => {
  const hasData = data.some((d) => d.value > 0);

  return (
    <SectionCard title={title} description={description} className="dashboard-pie-chart">
      {hasData ? (
        <div className="container" data-cy={`dashboard-pie-${title.toLowerCase().replace(/\s+/g, '-')}`}>
          <div className="chart">
            <Pie
              data={data}
              responsive
              arcLabelFormat="percentage"
              tooltipFormat="dollars"
              showArcLabels={false}
              enableArcLinkLabels={true}
              arcLinkLabelsSkipAngle={5}
              arcLinkLabelsOffset={-2}
              arcLinkLabelsDiagonalLength={10}
              arcLinkLabelsStraightLength={8}
              arcLinkLabelsThickness={0}
              arcLinkLabelsTextColor={{ from: 'color', modifiers: [['darker', 1]] }}
              arcLinkLabelType="value"
              margin={{ top: 25, right: 50, bottom: 25, left: 50 }}
            />
          </div>
          <div className="legend">
            {data.map((item) => (
              <div key={item.id} className="legend-item">
                <span className="legend-color" style={{ backgroundColor: item.color }} />
                <div className="legend-text">
                  <span className="legend-label">{item.label}</span>
                  <span className="legend-value">{formatCompactCurrency(item.value)}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="no-data" role="status">
          <Icon icon={faInfoCircle} />
          No data available for the selected period.
        </div>
      )}
    </SectionCard>
  );
};
